module.exports = __webpack_public_path__ + "static/clean-trucks-program-87c0870046460a1fdb0152e0158952c2.jpg";